// Team Member Modal Popout
(function($) {
	var timeout;
	var $target = $('.slider-item-team-member .team-member .description');
	var action = function() {
		$target.each((i, description) => {
			$(description).toggleClass('overflowed', isOverflowed($(description)))
		});
	}

	var isOverflowed = function (element) {
		var top = parseInt(element.css('padding-top'))
		var bottom = parseInt(element.css('padding-bottom'))
		var elem = element[0];
		var contentHeight = element.find('> *')
			.map((i, item) =>
				$(item).outerHeight(true)
			)
			.get()
			.reduce((a, b) =>
				a + b
			);

		return contentHeight > elem.clientHeight - (top + bottom);
	}

	$(window).on('resize', function() {
		if(timeout) window.clearTimeout(timeout);

		window.setTimeout(action, 500);
	});

	$target.on('click', '.read-more', function() {
		$.magnificPopup.open({
			closeOnBgClick: true,
			closeOnContentClick: false,
			showCloseBtn: true,
			closeBtnInside: true,
			enableEscapeKey: true,
			items: {
				src: $('<div></div>').append($('<div class="standard-modal"></div>').append($(this).parents('.description').clone(true))).html(),
				type: 'inline'
			}
		});
	});

	// Append the read more button even though it may be hidden...
	$target.append('<a class="read-more" href="#read-more">Read on <i class="fas fa-chevron-right fa-sm"></i></a>');

	// Run the check on the heights after above code is rendered.
	action();
})(jQuery);
